import DashboardLayout from "components/Layouts/DashboardLayout";
import PageHeader from "components/PageHeader";
import React from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Route, Switch } from "react-router-dom";
import Roles from "./Roles";
import { useSelector } from "react-redux";
import { isAdmin } from "data/app/appSelectors";
import AddRole from "./Roles/RolesForm/AddRole";
import EditRole from "./Roles/RolesForm/EditRole";

export default () => {
	const { t } = useTranslation();
	const admin = useSelector(isAdmin);

	return (
		<DashboardLayout>
			<div className="container admin__container">
				{admin ? (
					<>
						<PageHeader
							title={t(
								"main.admin.headings.pageTitle"
							)}></PageHeader>
						<div className="admin__content">
							<div className="admin__main">
								<div className="admin__main-container">
									<Switch>
										<Route
											exact
											path="/admin/roles"
											render={() => <Roles />}
										/>
										<Route
											exact
											path="/admin/roles/add-role"
											render={() => <AddRole />}
										/>
										<Route
											exact
											path="/admin/roles/edit-role/:role"
											render={() => <EditRole />}
										/>
										{/* HACK: redirect to admin/roles for now since theres only one section available
										<Redirect to="/admin/roles" /> */}
									</Switch>
								</div>
							</div>
						</div>
					</>
				) : (
					<Redirect to="/403" />
				)}
			</div>
		</DashboardLayout>
	);
};
